export const IMPERSONATION_REVOKED_EVENT = 'cakto:impersonation-revoked';
export const IMPERSONATION_REVOKED_MESSAGE_KEY = 'impersonationRevokedMessage';

export const isImpersonatingSession = () => {
  if (typeof window === 'undefined') return false;
  return Boolean(localStorage.getItem('impersonatedUserId'));
};

export const IMPERSONATION_REVOKED_TITLE = 'Acesso como convidado removido';
export const IMPERSONATION_REVOKED_MESSAGE =
  'Seu convite não está mais ativo. Você voltou para a sua própria conta.';

const IMPERSONATION_ACCESS_ERROR_CODES = [
  'collaborator_invite_invalid',
  'collaborator_invite_removed',
  'collaborator_invite_expired',
  'collaborator_access_revoked',
  'impersonation_access_revoked',
  'impersonation_not_allowed',
];

export const persistImpersonationRevokedMessage = (
  message = IMPERSONATION_REVOKED_MESSAGE
) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(IMPERSONATION_REVOKED_MESSAGE_KEY, message);
};

export const consumeImpersonationRevokedMessage = () => {
  if (typeof window === 'undefined') return null;

  const message = localStorage.getItem(IMPERSONATION_REVOKED_MESSAGE_KEY);
  if (message) {
    localStorage.removeItem(IMPERSONATION_REVOKED_MESSAGE_KEY);
  }

  return message;
};

export const dispatchImpersonationRevoked = (
  message = IMPERSONATION_REVOKED_MESSAGE
) => {
  if (typeof window === 'undefined') return;

  persistImpersonationRevokedMessage(message);
  window.dispatchEvent(
    new CustomEvent(IMPERSONATION_REVOKED_EVENT, {
      detail: { message },
    })
  );
};

export const isImpersonationAccessError = (error) => {
  const status = error?.response?.status;
  if (![401, 403, 404].includes(status)) return false;

  const data = error?.response?.data || {};
  const code = data.code || data.error_code || data.detail_code;
  return code
    ? IMPERSONATION_ACCESS_ERROR_CODES.includes(String(code))
    : false;
};
